import { BallMarker } from '@labradorsports/assets';
import { HighlightedSearchText, PlayTagDisplay } from '@labradorsports/components';

import { useNavigateWithQuery } from '../../../shared/providers/index.js';

interface Props {
    result: any;
    onClick: (result: any) => void;
}

const PlaySearchResult: FC<Props> = ({ result, onClick }) => {
    const navigate = useNavigateWithQuery();

    const showPlay = () => {
        onClick(result);

        const stateMod: any = {
            playId: result.playId,
        };
        if (result.teamId) {
            stateMod.teamId = result.teamId;
        }
        navigate('/playbook', stateMod);
    };

    return (
        <div className="play-search-result search-result" onClick={showPlay}>
            <BallMarker className="play-search-result-icon" />
            <div className="flex-grow-1">
                <div className="d-flex">
                    <div className="flex-grow-1">
                        <HighlightedSearchText text={result._highlightResult.name.value} />{' '}
                    </div>
                    <div>
                        {result.teamName ? (
                            <HighlightedSearchText text={result._highlightResult.teamName.value} />
                        ) : (
                            'My Playbook'
                        )}
                    </div>
                </div>
                <div className="small">
                    <HighlightedSearchText text={result._highlightResult.description?.value} />{' '}
                </div>
                <div>
                    <PlayTagDisplay tags={result.tags} />
                </div>
            </div>
        </div>
    );
};

export default PlaySearchResult;
